import React, { useState, useEffect } from "react";
import Chip from "@material-ui/core/Chip";
import Modal from './modal'
import { makeStyles } from "@material-ui/core/styles";
import { ADMIN, GUEST, IPAAS_DEV, RPA_DEV } from '../../../../../../services/config';

import './Chip.css'

const useStyles = makeStyles({
    chip: {
        margin: "10px",
        border: '2px solid #4A94CB'
    },
});

function Chips(props) {

    const [open, setOpen] = useState(false);
    const [roleItem, setRoleItem] = useState('')
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
            {props.roles && setIsLoaded(true)}
    },[props.roles]);

    const roles = props.roles

    const handleDelete = (role, isErasable) => {
        if(isErasable){
            setRoleItem(role.id)
            setOpen(true)
         }

    };

    const isRemovable = (role_name) => {
        if (props.user === ADMIN.ID && role_name === ADMIN.ROLE_NAME) {
            return false;
        }
        else if (props.user === GUEST.ID && role_name === GUEST.ROLE_NAME) {
            return false;
        }
        else if (props.user === IPAAS_DEV.ID && role_name === IPAAS_DEV.ROLE_NAME) {
            return false;
        }
        else if (props.user === RPA_DEV.ID && role_name === RPA_DEV.ROLE_NAME) {
            return false;
        }
        else{ return true;}
    }
    
    const classes = useStyles()
    
    return (
        <>
            {isLoaded
                ? props.roles.map((role, index) => {
                      return (
                          <Chip
                              key={index}
                              variant="outlined"
                              label={role.role_name}
                              onDelete={isRemovable(role.role_name) ? (e) => handleDelete(role, true) : handleDelete(role, false)}
                              className={classes.chip}
                              id='chip'
                          />
                      );
                  })
                : null}
                {open && <Modal open={open} setOpen={setOpen} roleItem={roleItem} user={props.user} roles={{...roles}} setRoles={props.setRoles}/>}
        </>
    );
}

export default Chips;
